import React, { useEffect, useRef } from 'react';
import { LinearProgress } from '@material-ui/core';
import widgetRender from './bei-light';

function chartRendering(data, action, array, date) {
  // json parametres de la viz
  const widgetProperties_chart1 = {
    generalProperties: {
      chartType: 'dotPlot', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 100, right: 40, bottom: 120, left: 100 },
      minMargin: { top: 40, right: 40, bottom: 80, left: 80 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 300, height: 300 },
      activeClipPath: false,
      svgOverflow: 'visible',
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      adjustPct: false,

      chartSubtype: 'YY', // YY : 2 linearAxis, XX : 2 categoricalAxis

      serieFields: ['analystName'],
      serieFieldsDatatype: ['text'],
      serieFieldsFormat: null,
      serieFieldsCustomSort: null,
      serieFieldsSortOrder: null,

      calculationFields: ['SalesGrowth', 'EBITDAMargin'],
      calculationFieldsLabel: ['Sales Growth', 'EBITDA Margin'],
      calculationFieldsDatatype: ['number', 'number'],
      calculationFieldsSortOrder: ['asc', 'asc'],
      calculationFieldsFormat: [null],

      sizeFields: [null],
      sizeFieldsLabel: [null],
      sizeFieldsDatatype: [null],
      sizeFieldsFormat: [null],

      styles: {
        themeScheme: null,
        colors: {
          defaultColor: '#F7DCC6',
          defaultStrokeColor: '#F7DCC6',
          defaultFillColor: '#F7DCC6',
          dimensionField: ['analystType'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: [
            'Venture Capital',
            'PE',
            'SWF',
            'Mutual Fund',
            'Pension Fund',
            'Hedge Fund',
            'Corporate',
            'Holding Company',
            'Company'
          ],
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: 'scaleOrdinal', // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: [
            '#002380',
            '#1E90A6',
            '#75C8C4',
            '#A3E3C0',
            '#CFFCD2',
            '#F8FEB1',
            '#F2ED88',
            '#FCECBD',
            'red'
          ],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: 'none'
        }
      },
      dataFiltering: {
        active: true,
        restrictionColumn: ['date'],
        restrictionColumnToValue: [2020]
      },
      dataHighlight: {
        applyOnAdjustedValue: false,
        rules: [
          {
            rule: 'fieldValue',
            field: 'analystType',
            fieldDataType: 'text',
            value: 'Company',
            operator: '===',
            color: 'red'
          }
        ]
      },
      filterSelectors: {
        filters: [
          {
            UI: 'toggleButton',
            active: true,
            visibleInAnimation: false,
            classnames: '',
            btnWidth: 50,
            btnFontFamily: 'Montserrat',
            btnFontSize: '12px',
            btnFontWeight: '200',
            btnFontStyle: 'normal',
            backgroundColor: 'transparent',
            labelColor: '#E86E07',
            selectedBackgroundColor: '#E86E07',
            selectedLabelColor: '#F5F5F5',
            multiSelection: false,
            hPosition: 'right',
            vPosition: '60px',
            hPadding: 10,
            vPadding: 0,
            text: 'Year : ',
            fontFamily: 'Montserrat',
            fontSize: '12px',
            fontWeight: '200',
            fontStyle: 'italic',
            color: '#E86E07',
            field: 'date',
            fieldType: 'numeric',
            fieldsFormat: null,
            values: [2020, 2021, 2022, 2023, 2024],
            selectedValue: 2020,
            action: 'render',
            actionState: 'updateData'
          }
        ]
      },
      XYChart: {
        nodeShape: 'rectangle', // rectangle (for stacked), circle (overlay/ranking)
        nodeSize: [5, 5], //	5 , or if there is a sizeField then [minSize, maxSize]
        nodeStroke: 'transparent',
        nodeStrokeWidth: 1,
        nodeStrokeOpacity: 1,
        nodeFillOpacity: 0.7,

        includeOrigin: [false, false], // could be [true, true] or true : then it's apply to all calculationFields
        linearGridline: [true, true],
        linearGridlineNumber: [8, 8],
        linearAxis: true,
        linearAxisTitle: ['Sales Growth', 'EBITDA Margin'],
        linearAxisLabel: true,
        linearAxisLabelFormat: ['.3~%'],
        linearAxisTick: true,
        linearAxisTicksNumber: [8, 8],
        linearAxisTickSize: 6,
        linearAxisMinMax: null,
        linearAxisMinMaxExtendFactor: null,
        linearAxisMinMaxAdjust: true,
        linearAxisReverse: null,
        linearAxisLabelTextWrapWidth: 50,
        linearAxisLabelTextWrapLineHeight: 2,

        sizeAxisMinMax: null,
        sizeAxisMinMaxExtendFactor: null,
        sizeAxisReverse: null,
        referenceLines: [
          {
            type: 'point', // line, band, area, point
            axis: null, // linear, categorical
            values: [0.15, 0.01],
            valuesShowOnAxis: false,
            includeInScale: true,
            color: 'red',
            dashArray: '0',
            width: 5
          }
        ]
      },
      label: {
        visible: false,
        text: '[analystName]',
        restrictionColumn: null,
        restrictionColumnToValue: null,
        position: 'center',
        hPadding: 20,
        vPadding: 0,
        relativePosition: 'outside',
        fontFamily: 'Montserrat',
        fontSize: '12px',
        fontWeight: '400',
        textAnchor: 'middle',
        dy: '-1em',
        altTextAnchor: null,
        color: '#878786',
        altColor: '#FFFFFF',
        suffix: null,
        suffixDy: null,
        suffixDx: null,
        suffixFontWeight: null,
        suffixFontSize: null,
        SVG: null,
        variableFormat: {
          year: { datatype: 'date', formatIn: '%d-%m-%Y', formatOut: '%B %Y' },
          actifNet: { datatype: 'number', formatOut: '$,.1d' },
          souscriptionNet: { datatype: 'number', formatOut: '$,.1d' }
        }
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        lineWidth: 1,
        altColor: '#000000',
        labelColor: '#555555',
        padding: 0,
        tickPadding: 5,
        tickSize: 5,
        title: true,
        titlePosition: 'outside',
        titleRelPosition: 'middle',
        titlePadding: 10,
        titleFontSize: '14px',
        titleFontWeight: 'normal'
      },
      gridline: {
        dashArray: '2 2',
        showExtend: true,
        color: '#979797',
        width: 0.5,
        altColor: '#000000',
        opacity: 0.5
      },
      title: {
        visible: false,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '18px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>OPERATING METRICS</tspan></text>"
      },
      legend: {
        type: 'colorScheme', // manual, data, dimension, measure
        scaleMode: 'categorical', // null, categorical, continous
        marker: 'square', // square, roundedSquare, circle, line
        markerSize: 14,
        text: null,
        orientation: 'horizontal',
        hPosition: 'centerViz',
        vPosition: 'bottom',
        hPadding: 0,
        vPadding: 45,
        alignment: 'center',
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353',
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        textAnchor: 'start',
        blockPadding: 20,
        maxBlockPerRow: 5,
        minBlockSize: 120,
        SVG:
          "<g class='element'><text dy='0.9em'><tspan>[analystName] </tspan></text></g>",
        // 'SVG' : null,
        variableFormat: {
          cout: {
            datatype: 'number',
            formatOut: '$,.2d',
            removeFormatPctSign: false
          },
          __pct__: {
            datatype: 'number',
            formatOut: '.1~%',
            removeFormatPctSign: false
          }
        }
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        pointer: true,
        hRelPosition: 'center',
        vRelPosition: 'up',
        lineSeparator: true,
        fontFamily: 'Montserrat',
        vPadding: -10,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        borderRadius: 0,
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='95' style='stroke : [shapeColor];stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>Investor type : [analystType]</tspan><tspan x='25' y='50'>Analyst Name : [analystName]</tspan><tspan x='25' y='72'>Sales Growth : [SalesGrowth]</tspan><tspan x='25' y='92'>EBITDA Margin : [EBITDAMargin]</tspan></text></g>",
        variableFormat: {
          SalesGrowth: {
            datatype: 'number',
            formatIn: '.4',
            formatOut: '.3~%'
          },
          EBITDAMargin: {
            datatype: 'number',
            formatIn: '.4',
            formatOut: '.3~%'
          }
        },
        tooltipSpecificFn: null
      },
      annotation: {
        active: true,
        visible: true,
        annotationToggleIndicator: {
          visible: true,
          visibleInAnimation: false,
          hPosition: 'leftPlot',
          vPosition: 'topPlot',
          hPadding: 5,
          vPadding: -25
        }
      },
      animation: {
        active: true,
        duration: 1000,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeLinear' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartDispersion',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  widgetRender(widgetProperties_chart1, action);
}
const ChartDispersion = ({ data, loading, error, array, date }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */
  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        chartRendering(data, 'init', array, date);
      }
    } else d3svg.current = true;
  }, [array, data, date]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartDispersion"
        role="img"
        style={{ width: '100%', height: '700px' }}>
        {loading && (
          <h6>
            <LinearProgress />
          </h6>
        )}
        {error && <h4>{error}</h4>}
      </div>
    </>
  );
};

export default ChartDispersion;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
